import { permissionManager } from "../PermissionManager/PermissionManager";
import {
  OPEN_FILE_FROM_GOOGLE_DRIVE,
  OPEN_FILE_FROM_ONE_DRIVE,
  OPEN_FILE_FROM_BOX,
  OPEN_FILE_FROM_DROPBOX,
  OPEN_FILE_FROM_DRIVES,
  OPEN_DRIVES_CLASS,
} from './openfile.constants';

import {
  SAVE_TO_DOWNLOAD,
  SAVE_TO_DRIVES,
  SAVE_TO_DRIVES_CLASS,
} from './savefile.constants';
export const OPEN_FILE_FROM_URL_MOBILE = 'fv--open-fromurl-button';
export const USER_ENTRY_SIGN_IN = 'fv--topbar-user-button-sign-in';
export const USER_ENTRY_SIGN_UP = 'fv--topbar-user-button-sign-up';

export const USER_SWITCH_LANGUAGE = 'fv--topbar-lang-button';
export const USER_SWITCH_LANGUAGE_ = USER_SWITCH_LANGUAGE + '-';
export const USER_SWITCH_LANGUAGE_EN = USER_SWITCH_LANGUAGE_ + 'en';
export const USER_SWITCH_LANGUAGE_ZH = USER_SWITCH_LANGUAGE_ + 'zh';
export const USER_SWITCH_LANGUAGE_JA = USER_SWITCH_LANGUAGE_ + 'ja';
export const USER_SWITCH_LANGUAGE_DE = USER_SWITCH_LANGUAGE_ + 'de';
export const USER_SWITCH_LANGUAGE_FR = USER_SWITCH_LANGUAGE_ + 'fr';
export const USER_SWITCH_LANGUAGE_KO = USER_SWITCH_LANGUAGE_ + 'ko';

export const USER_GOTO_ADMIN_CONSOLE = 'fv__icon-mobile-goto-admin-button';
export const USER_GOTO_EXIT = 'fv__icon-mobile-goto-exit-button';
export const VIEWER_SEARCH_BTN = 'fv--mobile-topbar-search-button';
export const HAND_TOOL_MOBILE = 'hand-tool';
export const USER_POLICY = 'fv__icon-mobile-user-policy'
export const USER_TERMS = 'fv__icon-mobile-user-terms'

export const USER_ACCOUNT = 'fv__icon-mobile-user-account'


permissionManager.registerNotLoginFeatures([
  USER_GOTO_EXIT,
  USER_ENTRY_SIGN_IN,
  USER_ENTRY_SIGN_UP,
  USER_SWITCH_LANGUAGE,
  USER_SWITCH_LANGUAGE_EN,
  USER_SWITCH_LANGUAGE_ZH,
  USER_SWITCH_LANGUAGE_DE,
  USER_SWITCH_LANGUAGE_FR,
  USER_SWITCH_LANGUAGE_JA,
  USER_SWITCH_LANGUAGE_KO]);

//fv--open-fromurl-button
export const MOBILE_LIST = [
  OPEN_FILE_FROM_URL_MOBILE,
  OPEN_FILE_FROM_GOOGLE_DRIVE,
  OPEN_FILE_FROM_ONE_DRIVE,
  OPEN_FILE_FROM_BOX,
  OPEN_FILE_FROM_DROPBOX,
  USER_ENTRY_SIGN_IN,
  USER_ENTRY_SIGN_UP,
  USER_GOTO_ADMIN_CONSOLE,
  USER_GOTO_EXIT,
  USER_SWITCH_LANGUAGE
];

export const saveFileTargetAndClass = [
  {
    action: 'after',
    target: SAVE_TO_DOWNLOAD,
    name: SAVE_TO_DRIVES,
    class: SAVE_TO_DRIVES_CLASS,
    text: 'phantom_online:toolbar.buttons.saveToDrives',
  },
];

export const openFileTargetAndClass = [
  {
    action: 'after',
    target: OPEN_FILE_FROM_URL_MOBILE,
    name: OPEN_FILE_FROM_DRIVES,
    class: OPEN_DRIVES_CLASS,
    text: 'phantom_online:toolbar.buttons.openFromDrives',
  }
];

